/**
 * Loja selecionada pelo cliente (multi-store). Persistida num cookie
 * NÃO httpOnly (o SSR lê no boot; o browser lê para exibir a atual),
 * 1 ano, sameSite=lax — mesmo contrato do app v1 (`selected_store`).
 */

import { SELECTED_STORE_COOKIE, COOKIE_MAX_AGE } from "@/config/cookies";
import { readClientCookie, writeClientCookie } from "@/shared/helpers/cookies";

export { SELECTED_STORE_COOKIE } from "@/config/cookies";

/** Lê o id da loja selecionada no browser; null se não houver. */
export function readSelectedStoreId(): number | null {
    const raw = readClientCookie(SELECTED_STORE_COOKIE);
    const id = raw !== null ? Number(raw) : NaN;

    return Number.isFinite(id) && id > 0 ? id : null;
}

/** Persiste a loja selecionada (browser). O SSR passa a resolvê-la no boot. */
export function writeSelectedStoreId(storeId: number): void {
    writeClientCookie(SELECTED_STORE_COOKIE, String(storeId), COOKIE_MAX_AGE.year);
}
